import { render, staticRenderFns } from "./DragPanel.vue?vue&type=template&id=475795d0&scoped=true"
import script from "./DragPanel.vue?vue&type=script&lang=js"
export * from "./DragPanel.vue?vue&type=script&lang=js"
import style0 from "./DragPanel.vue?vue&type=style&index=0&id=475795d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475795d0",
  null
  
)

export default component.exports